module.exports = __webpack_public_path__ + "static/img/mob-5.ffca9440.jpeg";